<template>
    <StepWrapper v-if="isActiveStep(step)" :step="step">
        <div class="solutionguide__grid">
            <div v-for="component in application.components" class="solutionguide__grid-item" @click="() => selectComponent(component)">
                <button class="button">
                    <img class="solutionguide__grid-icon" :src="component.icon" :alt="component.name" width="100" height="100" />
                </button>
                <div class="solutionguide__grid-label">
                    {{component.name}}
                </div>
            </div>
        </div>
        <div class="button-wrapper">
            <GlobalButton theme="secondary" @click="back">{{ $t('component.button.back') }}</GlobalButton>
        </div>
    </StepWrapper>
</template>

<script lang="ts">
    import Vue from "vue";
    import {mapGetters, mapState} from "vuex";
    import {STEP} from "../store/solutionGuideStore"
    import StepWrapper from "./step-wrapper.vue";
    import {SolutionGuide} from "../../../../../_types/solutionguide";
    import GlobalButton from "../../../../../global/global-elements/global-button/global-button.vue";

	export default Vue.extend({
        name: "step-component",
        components: {GlobalButton, StepWrapper},
        data() {
            return {
                step: STEP.Component
            }
        },
        computed: {
            ...mapState(['application']),
            ...mapGetters(['isActiveStep']),
        },
        methods: {
            selectComponent(component: SolutionGuide.Component) {
                this.$store.commit('selectComponent', component)
            },
            back() {
                this.$store.commit('back', STEP.Application)
            }
        }
    })
</script>
